<div class="calendar">
  <button type="button" class="calendar__trigger" [ngClass]="'calendar__trigger--' + size"
          [class.calendar__trigger--open]="isOpen()" [disabled]="disabled" (click)="toggle()">
    <img class="calendar__icon" src="assets/icon/calendar.svg" alt="" />
    <span class="calendar__label">{{ displayLabel() || (placeholderLabel() | translate) }}</span>
    <img class="calendar__chevron" [src]="isOpen() ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'" alt="" />
  </button>

  @if (isOpen()) {
    <div class="calendar__panel" (click)="$event.stopPropagation()">

      @if (view() === 'day') {
        <div class="calendar__panel-header">
          <button type="button" class="calendar__nav" (click)="prevPeriod()">
            <img src="assets/icons/arrow-left.svg" alt="" />
          </button>
          <button type="button" class="calendar__period-label" (click)="goToView('month')">{{ monthLabel() }}</button>
          <button type="button" class="calendar__nav" (click)="nextPeriod()">
            <img src="assets/icons/arrow-right.svg" alt="" />
          </button>
        </div>
        <div class="calendar__weekdays">
          @for (w of weekdayLabels(); track $index) {
            <span>{{ w }}</span>
          }
        </div>
        <div class="calendar__days">
          @for (week of weeks(); track $index) {
            @for (day of week; track day.date.getTime()) {
              <button type="button" class="calendar__day"
                [class.calendar__day--muted]="!day.inCurrentMonth"
                [class.calendar__day--today]="day.isToday"
                [class.calendar__day--selected]="day.isSelected"
                (click)="selectDay(day)">
                {{ day.day }}
              </button>
            }
          }
        </div>
      }

      @if (view() === 'month') {
        <div class="calendar__panel-header">
          <button type="button" class="calendar__nav" (click)="prevPeriod()">
            <img src="assets/icons/arrow-left.svg" alt="" />
          </button>
          <button type="button" class="calendar__period-label" (click)="goToView('year')">{{ yearLabel() }}</button>
          <button type="button" class="calendar__nav" (click)="nextPeriod()">
            <img src="assets/icons/arrow-right.svg" alt="" />
          </button>
        </div>
        <div class="calendar__months">
          @for (m of monthsGrid(); track m.index) {
            <button type="button" class="calendar__month" [class.calendar__month--selected]="m.isSelected" (click)="selectMonth(m.index)">
              {{ m.label }}
            </button>
          }
        </div>
      }

      @if (view() === 'year') {
        <div class="calendar__panel-header">
          <button type="button" class="calendar__nav" (click)="prevPeriod()">
            <img src="assets/icons/arrow-left.svg" alt="" />
          </button>
          <span class="calendar__period-label calendar__period-label--static">{{ yearBlockLabel() }}</span>
          <button type="button" class="calendar__nav" (click)="nextPeriod()">
            <img src="assets/icons/arrow-right.svg" alt="" />
          </button>
        </div>
        <div class="calendar__years">
          @for (y of yearsGrid(); track y.year) {
            <button type="button" class="calendar__year" [class.calendar__year--selected]="y.isSelected" (click)="selectYear(y.year)">
              {{ y.year }}
            </button>
          }
        </div>
      }

      <div class="calendar__footer">
        <div class="calendar__view-toggle">
          <button type="button" class="calendar__toggle-btn" [class.calendar__toggle-btn--active]="view() === 'day'" (click)="goToView('day')">{{ 'CALENDAR.DAY' | translate }}</button>
          <button type="button" class="calendar__toggle-btn" [class.calendar__toggle-btn--active]="view() === 'month'" (click)="goToView('month')">{{ 'CALENDAR.MONTH' | translate }}</button>
          <button type="button" class="calendar__toggle-btn" [class.calendar__toggle-btn--active]="view() === 'year'" (click)="goToView('year')">{{ cursor().getFullYear() }}</button>
        </div>
        <button type="button" class="calendar__confirm" [disabled]="!hasPendingSelection" (click)="confirm()">{{ 'BUTTONS.CONFIRM' | translate }}</button>
      </div>

    </div>
  }
</div>
